import { jsxs as _jsxs } from "react/jsx-runtime";
import { AwardIcon } from '@gemini/icons';
import { Tag } from '@gemini/ui';
const Seniority = ({ startYear, t }) => {
    return (_jsxs(Tag, { icon: AwardIcon, variant: "light", children: [t('wlac_agency_seniority'), " ", startYear] }));
};
export default Seniority;
